var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBillIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_9221",
    "data-name": "Group 9221",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14.037,
    height: 18.132,
    viewBox: "0 0 14.037 18.132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3125",
    "data-name": "Rectangle 3125",
    width: 14.037,
    height: 18.132,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9220",
    "data-name": "Group 9220",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_256",
    "data-name": "Path 256",
    d: "M0,9.173Q0,5.548,0,1.924a1.8,1.8,0,0,1,.274-1A1.855,1.855,0,0,1,1.6.039,3.312,3.312,0,0,1,2.075,0q4.99,0,9.981,0a1.872,1.872,0,0,1,.969.222,1.9,1.9,0,0,1,.988,1.407A2.474,2.474,0,0,1,14.036,2q0,7.224,0,14.447a1.476,1.476,0,0,1-.194.762,1.252,1.252,0,0,1-1.539.5q-.326-.15-.646-.31c-.433-.216-.866-.434-1.3-.656a.279.279,0,0,0-.287,0c-.794.408-1.592.808-2.388,1.212a1.389,1.389,0,0,1-.755.176,1.181,1.181,0,0,1-.4-.1q-.808-.376-1.612-.758-.414-.2-.826-.4a.229.229,0,0,0-.208,0q-.679.3-1.361.59a8.706,8.706,0,0,1-.9.357,1.266,1.266,0,0,1-1.6-1.026A2.037,2.037,0,0,1,0,16.461q0-3.644,0-7.289m1.273,7.414c.035-.012.06-.02.083-.03.619-.265,1.237-.532,1.857-.8a3.565,3.565,0,0,1,.421-.15,1.483,1.483,0,0,1,.333-.054,1.371,1.371,0,0,1,.662.155q1.144.55,2.287,1.1a.179.179,0,0,0,.177,0q.722-.369,1.447-.734c.352-.178.7-.361,1.06-.529a1.406,1.406,0,0,1,.832-.137,1.445,1.445,0,0,1,.429.152l1.8.918c.028.014.059.024.1.042v-.133q0-7.159,0-14.317c0-.05,0-.1,0-.149a.639.639,0,0,0-.476-.617,1.293,1.293,0,0,0-.316-.033q-4.97,0-9.94,0A1.068,1.068,0,0,0,1.79,1.3a.6.6,0,0,0-.483.449,1.218,1.218,0,0,0-.032.306q0,7.208,0,14.417Z",
    transform: "translate(0 0)",
    fill: "#393939"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_257",
    "data-name": "Path 257",
    d: "M64.2,133.38c-1.023,0-2.046,0-3.07,0a1.174,1.174,0,0,1-.313-.044.617.617,0,0,1-.3-.957.61.61,0,0,1,.441-.241c.1-.008.192-.017.287-.017q3,0,6.01,0a1.383,1.383,0,0,1,.285.035.609.609,0,0,1,.025,1.183,1.165,1.165,0,0,1-.3.04q-1.53,0-3.06,0",
    transform: "translate(-57.181 -125.093)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_258",
    "data-name": "Path 258",
    d: "M64.144,73.38c-1.03,0-2.06,0-3.089,0a.692.692,0,0,1-.536-.2.614.614,0,0,1,.366-1.045,2.514,2.514,0,0,1,.327-.019q2.99,0,5.98,0a1.415,1.415,0,0,1,.295.036.609.609,0,0,1,.021,1.183,1.128,1.128,0,0,1-.294.04q-1.535,0-3.07,0",
    transform: "translate(-57.126 -68.283)",
    fill: "#0094d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_259",
    "data-name": "Path 259",
    d: "M62.755,193.377c-.568,0-1.136,0-1.7,0a.684.684,0,0,1-.54-.208.614.614,0,0,1,.376-1.032,2.431,2.431,0,0,1,.327-.019q1.6,0,3.208,0a.853.853,0,0,1,.387.075.6.6,0,0,1,.364.562.612.612,0,0,1-.449.582,1.112,1.112,0,0,1-.294.04c-.558,0-1.116,0-1.674,0",
    transform: "translate(-57.13 -181.898)",
    fill: "#0094d1"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBillIcon);
export default __webpack_public_path__ + "static/media/bill-icon.32f4a1546a85038f340c65aaa8be2dd0.svg";
export { ForwardRef as ReactComponent };